import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import CartDrawer from "./CartDrawer";
import LanguageToggle from "./LanguageToggle";
import StickyBuyBar from "./StickyBuyBar";
import { Toaster } from "./ui/sonner";

const Layout = () => {
  return (
    <div className="min-h-screen bg-[#FFFBF5] text-[#2C3E50]">
      <Navbar />
      <LanguageToggle />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CartDrawer />
      <StickyBuyBar
        productId="mothers-care-kitchen-cool-fan"
        productName="Kitchen Cool Fan"
      />
      <Toaster richColors position="top-center" />
    </div>
  );
};

export default Layout;
